export class BdPermissionsCompanyAdminStore {

  constructor(
    private readonly _baseUrl: string
  ) {
  }

  public index(): string {
    return `${this.base()}/companies/`
  }

  public getAll(): string {
    return `${this.base()}/companies/all`;
  }

  public getByCompanyId(companyId: string): string {
    return `${this.base()}/companies/${companyId}`;
  }

  public getGroupsByCompanyId(companyId: string): string {
    return `${this.base()}/companies/${companyId}/groups/`;
  }

  public getMembersByCompanyId(companyId: string): string {
    return `${this.base()}/companies/${companyId}/members/`;
  }

  public companyDeletionCheck(companyId: string): string {
    return `${this.base()}/companies/${companyId}/deletion-check`;
  }

  public companyContentPurge(companyId: string): string {
    return `${this.base()}/companies/${companyId}/content-purge`;
  }

  private base(): string {
    return this._baseUrl;
  }
}
